<template>
  <div class="wrap">
    <table class="row box-content" style="width: 70%">
      <tr class="table__row">
        <td align="left"><div class="title">{{translate('company')}}: </div></td>
        <td align="left"><div>{{rfq.customerCompany.name}}</div></td>
      </tr>
      <tr class="table__row">
        <td align="left"><div class="title">{{translate('contact-name')}}: </div></td>
        <td align="left"><div>{{rfq.customerContact.name}}</div></td>
      </tr>
      <tr class="table__row">
        <td align="left"><div class="title">{{translate('date')}}: </div></td>
        <td align="left"><div>{{rfq.entryDate | toDate}}</div></td>
      </tr>
    </table>
    <table-list
      :columns="[
          { label: translate('qty'), renderColumn: (row) => row.qty },
          { label: translate('part-number'), renderColumn: (row) => row.part.partNumber },
          { label: translate('description'), renderColumn: (row) => row.part.partDescription },
          { label: translate('condition'), renderColumn: (row) => row.condition.title },
          { label: translate('supply-date'), renderColumn: (row) => row.supplyDate },
          { label: translate('currency'), renderColumn: (row) => row.currency.title },
          { label: translate('u-price'), renderColumn: (row) =>  $options.filters.toPrice(row.price) },
          { label: translate('total'), renderColumn: (row) => $options.filters.toPrice(row.price * row.qty) },
        ]"
      :data="rfq3s"
    >
      <template v-slot="scope">
        <div class="table-div__tr">
          <span class="title">{{translate('cert-info')}}: </span>
          {{makeCertInfo(scope.item)}}
        </div>
        <div class="table-div__tr">
          <span class="title">{{translate('remarks')}}: </span>
          {{scope.item['remarks']}}
        </div>
      </template>
    </table-list>

    <table class="row">
      <tr class="table__row">
        <td align="right">
          <span class="title">{{translate('total-quote')}}: </span>{{rfq3sFirst.currency.title}} {{total | toPrice}}
        </td>
      </tr>
    </table>

    <div class="row">
      <div v-html="content.html1"></div>
    </div>

    <table>
      <tr>
        <td colspan="3">
          <h3>{{rfq.baxEmployee.name}}</h3>
        </td>
      </tr>
      <tr>
        <td>
          <span class="title">{{translate('phone')}}:</span>
          <span>{{rfq.baxEmployee.contact.phone}}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span class="title">{{translate('email')}}:</span>
          <span>{{rfq.baxEmployee.contact.email}}</span>
        </td>
      </tr>
    </table>

    <div class="row" style="width: 100%; text-align: center">
      <h3 v-html="content.html2"></h3>
    </div>

  </div>
</template>
<script>
import { toDate, toPrice } from '@/utils/filters'
import TableList from './components/table-list'

export default {
  name: 'PdfQuoteMultiParts',
  components: {
    'table-list': TableList
  },
  props: {
    translate: {
      type: Function
    },
    rfq: {
      type: Object
    },
    rfq3s: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    rfq3sFirst () {
      return this.rfq3s[0] || { currency: {} }
    },
    subTotal () {
      return this.rfq3s.reduce((result, detail) => result + (detail.qty * detail.price), 0)
    },
    total () {
      return this.subTotal
    }
  },
  methods: {
    makeCertInfo (rfq3) {
      return [
        rfq3.tagInfoCompany.name,
        rfq3.release.title,
        toDate(rfq3.tagDate)
      ].filter(Boolean).join('; ')
    }
  },
  filters: {
    toPrice: toPrice,
    toDate: toDate
  }
}
</script>
